import { TRANSCRIPT_SYNC_BACKOFF_MS } from "./constants";

export type SyncState = {
  lastSyncedTranscript: string;
  inFlight: boolean;
  consecutiveFailures: number;
};

export const createInitialSyncState = (): SyncState => ({
  lastSyncedTranscript: "",
  inFlight: false,
  consecutiveFailures: 0,
});

/**
 * Decide se vale gravar o transcript agora.
 * Recusa: escrita em voo (evita empilhar requests obsoletos com rede ruim),
 * texto inalterado, e qualquer texto menor que o ultimo confirmado
 * (protege contra reconexao do Soniox mandando parcial por cima do completo).
 */
export const shouldSync = (state: SyncState, transcript: string): boolean => {
  if (state.inFlight) return false;

  const candidate = transcript.trim();
  if (!candidate) return false;
  if (candidate === state.lastSyncedTranscript) return false;
  if (candidate.length < state.lastSyncedTranscript.length) return false;

  return true;
};

export const nextDelayMs = (consecutiveFailures: number): number => {
  const index = Math.min(Math.max(consecutiveFailures, 0), TRANSCRIPT_SYNC_BACKOFF_MS.length - 1);
  return TRANSCRIPT_SYNC_BACKOFF_MS[index];
};
